module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create_session":"Create Session","name":"Name","start_end_date":"Start Date & End Date","add_device":"Add Device","create":"Create","select_one_device":"Please select at least one device"}}')
  delete Component.options._Ctor
}
